export default __webpack_public_path__ + "static/media/2017 (5).3f7ec4d0.jpg";